// extracted by mini-css-extract-plugin
export default {"article--right":"Posts_article--right__gmiDH","article":"Posts_article__ca5o3","article--left":"Posts_article--left__cCMNx","middle--text":"Posts_middle--text__t0Rxy"};